import { render, staticRenderFns } from "./ChoosedOrder.vue?vue&type=template&id=258f7254&scoped=true&lang=pug&"
import script from "./ChoosedOrder.vue?vue&type=script&lang=js&"
export * from "./ChoosedOrder.vue?vue&type=script&lang=js&"
import style0 from "./ChoosedOrder.vue?vue&type=style&index=0&id=258f7254&prod&lang=sass&"
import style1 from "./ChoosedOrder.vue?vue&type=style&index=1&id=258f7254&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258f7254",
  null
  
)

export default component.exports